import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { registerLocale, setDefaultLocale } from "react-datepicker"; 
import dayjs from "dayjs";
import "dayjs/locale/tr";
import tr from "date-fns/locale/tr";
import App from "./App"; 

import { persistor, store } from "./store/store";

import "./styles/global.css";
import "./styles/buttons.scss";
import "./styles/radiobutton.scss";
import "./styles/loading.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

dayjs.locale("tr");

registerLocale("tr", tr);
setDefaultLocale("tr");





const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Redux Toolkit Provider */}
    <Provider store={store}>
      {/* Redux Persist middleware */}
      <PersistGate loading={null} persistor={persistor}>
        {/* Router */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

